import { Platform, Text } from 'react-native'
import { convertLineHeight, convertPercentageToNumber, styled } from '~/utils'

const IS_IOS = Platform.OS === 'ios'

export const Description = styled(Text, theme => {
  return {
    base: {
      textAlign: IS_IOS ? 'center' : 'left',
      color: theme.colorTextNeutralAlternative,
      fontSize: theme.fontSizeThreeandhalfpulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreeandhalfpulse,
        theme.lineHeightSmall
      ),
      fontFamily: theme.fontFamily.regular,
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
    },
  }
})
